import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import {CenteredContent} from 'components/container';
import Loading from 'components/loading';
import {Fallback} from 'components/fallback';
import Error from 'components/error';

const defaultReject = ()=>new Promise((resolve,reject) => setTimeout(() => reject(new Error("Issue")),5000));
const defaultResolve = ()=>new Promise((resolve,reject) => setTimeout(() => resolve({"value":"{}"}),5000));

export const Suspense = ({ 
  children, 
  payload:_payload, 
  refresh,
  promise = defaultResolve,
  fallback
  }) => {
    const [payload, setPayload] = React.useState();    

    React.useEffect(() => {             
      setPayload({ data: wrapPromise(() => promise(_payload)) });  
    }, [refresh,_payload]);   
    
    return !payload?<Loading />:
    <React.Suspense fallback={<Loading />}>     
      {React.cloneElement(children,{payload})}     
    </React.Suspense>;
  
};


export const Lazy = (Component) => ({payload={},...other}) =><Component {...payload?.data?.read()??{}} {...other} />;

// Function to wrap a promise with status handling
const wrapPromise = (promise) => {
  let status = "pending";
  let result;
  let suspend = promise().then(
    (res) => {
      status = "success";
      result = res;
    },
    (err) => {
      status = "error";
      result = err;
    }
  );
  return {
    // Read method to handle the promise status and result
    read() {
      if (status === "pending") {
        throw suspend;
      } else if (status === "error") {
        throw result;
      } else if (status === "success") {
        return result;
      }
    },
  };
};

export default ({children,payload,refresh,promise,fallback}) =>(
 <ErrorBoundary key={`error-${String(refresh)}`} FallbackComponent={fallback||Fallback} >
  <Suspense payload={payload} refresh={refresh} promise={promise} fallback={fallback}>          
    {children}
  </Suspense>   
    </ErrorBoundary>
 
);

